import {convertPriceToClient} from 'Common/helpers/convertPrices';

export function withPrice<T extends {price: number}>(model: T) {
  return {
    ...model,
    price: convertPriceToClient(model.price),
  };
}
